module.exports = __webpack_public_path__ + "site/img/1.9ecb828c.jpg";